const config = {
  'create-enrollments': (data) => ({
    data: { data },
    method: 'post',
    url: '/api/admin/enrollments/bulk_create',
  }),
  'get-enrollments': ({ isModalVariant, courseId, enrolledUsersQuery, signal }) => ({
    url: isModalVariant
      ? `/api/admin/enrollments/eligible_users?course_id=${courseId}`
      : `/api/admin/enrollments?course_id=${courseId}`,
    params: enrolledUsersQuery,
    signal,
  }),
  'get-groups': ({ signal }) => ({
    url: '/groups/list.json',
    signal,
  }),
};

export default (name, data) => config[name]?.(data) || {};
